var maps : {[kye : string] : string} = {
	'&'  : '&amp;',
	'<'  : '&lt;',
	'>'  : '&gt;',
	'\"' : '&quot;',
	'\'' : '&#039;'
}
var reverseMaps : {[kye : string] : string} = {}
for(var k in maps){
	reverseMaps[maps[k]] = k
}

export const encodeHTML = function (html : string) {
	html = ''+html
	return html.replace(/(&|<|>|'|")/g,(match)=> maps[match] || match)
}

export const decodeHTML = function (str : string) {
	str = ''+str
	return str.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g,function(match) {
		return reverseMaps[match] || match
	})
}